import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { TypeRampV2 } from "../../typography";
import { chipTheme } from "./chipTheme";

export const ChipLabelStyled = styled(TypeRampV2)<{
    chipSize: "xsmall" | "small" | "medium";
    themeMode: RequiredThemeKeys;
    fontSize?: string;
    fontWeight?: number;
    lineHeight?: string;
}>(
    ({ themeMode, chipSize, fontSize = "", fontWeight = "", lineHeight = "" }) => `
    padding: 0 6px 0 4px;
    letter-spacing: 0.2px;
    word-break: break-all;

    // Lodestar and Ursa Chips both use the same font styles
    font-size: var(--sds--chip--font-size, ${fontSize});
    padding-right: var(
        --sds--chip--label--padding-right,
        ${chipTheme.padding.right[chipSize](themeMode)}
    );
    padding-left: var(
        --sds--chip--label--padding-left,
        ${chipTheme.padding.left[chipSize](themeMode)}
    );
    font-weight: var(--sds--chip--label--weight, ${fontWeight});
    line-height: var(--sds--chip--label--line-height, ${lineHeight});
`
);
